export default __webpack_public_path__ + "static/media/back.c95678de.png";